const redirectToDomain = (path, response, domain, statusCode = 301) => {
  const target = `${domain}${path}`;

  if (response) {
    if (!response.finished) {
      response.writeHead(statusCode, { Location: target });
      response.end();
    }
  } else {
    window.location.replace(target);
  }
};

export default redirectToDomain;
